import React from 'react';
import UpdateStore from 'pages/Stores/UpdateStore';
import CreateStore from 'pages/Stores/CreateStore';
import { StoreInterface, useStoresContext } from 'pages/Stores/stores.context';
import EmptyData from 'components/Messages/EmptyData/EmptyData';
import { Brand, User } from '@restore/services-lib';
import { TableColumnInterface } from 'components/Table/table.types';
import { IconBox } from 'components/StyledComponents/IconBox';
import OverviewTable from 'components/Table/Table';
import ArchiveStore from 'pages/Stores/ArchiveStore';
import { Link } from 'react-router-dom';
import { Tag } from 'components/Tag/Tag';
import StoresFilter from './Filter';
import { hasPermissions } from 'config/ability';
import { useAuthContext } from 'context/auth.context';
import { truncateText } from 'utils/formatting';
import TagTableCellContainer from 'components/Tag/TagHelpers/TagTableCellContainer';

const StoresTable = (): JSX.Element => {
  const { stores } = useStoresContext();
  const { ability, userTenantId } = useAuthContext();

  const tableCols: TableColumnInterface<StoreInterface>[] = [
    { label: 'Store Number', value: (store) => store?.storeNumber },
    {
      label: 'Name',
      value: (store) => <Link to={`/stores/${store.id}`}>{truncateText(store?.name, 30)}</Link>,
      sortBy: 'name',
    },
    // { label: 'Address', value: (store) => store?.address, sortBy: 'address' },
    { label: 'State / Province', value: (store) => store?.state, sortBy: 'state' },
    {
      label: 'Brands',
      value: (store) => store.brands.map((brand: Brand) => brand.name).join(', '),
    },
    {
      label: 'Users',
      value: (store) =>
        store.users.map((user: User) => `${user.firstName} ${user.lastName}`).join(', '),
    },
    {
      label: 'Store Manager(s)',
      value: (store) =>
        (store.storeManagerUsers || [])
          .map((user: User) => `${user.firstName} ${user.lastName}`)
          .join(', '),
    },
    {
      label: 'Tags',
      value: (store) => (
        <TagTableCellContainer>
          {store.tags.map((tag) => (
            <Tag key={tag.id} color={tag.displayColour} text={tag.name} />
          ))}
        </TagTableCellContainer>
      ),
    },
    {
      label: '',
      align: 'right',
      value: (store) => (
        <IconBox>
          <UpdateStore store={store} showIcon={true} />
          <ArchiveStore store={store} showIcon={true} />
        </IconBox>
      ),
    },
  ];

  return (
    <>
      <StoresFilter />
      <OverviewTable
        data={stores.filter((store) => {
          return (
            !store.archived &&
            (hasPermissions(ability, 'read', 'Store', { tenantId: userTenantId }) ||
              hasPermissions(ability, 'read', 'Store', { storeId: store.id }))
          );
        })}
        columns={tableCols}
        tableTitle='Stores'
        tableActions={<CreateStore />}
        noDataMessageOverride={<EmptyData dataType='store' action={<CreateStore />} />}
        defaultSortedCol='name'
      />
    </>
  );
};

export default StoresTable;
